export function usePaginationInitialState(options: PaginationInitialStateOptions = {}) {
  const route = useRoute();
  const paginationDefaults = usePaginationDefaults();

  const pageQueryKey = options.pageQueryKey ?? paginationDefaults.pageQueryKey;
  const pageSizeQueryKey = options.pageSizeQueryKey ?? paginationDefaults.pageSizeQueryKey;
  const defaultPageSize = options.defaultPageSize ?? paginationDefaults.defaultPageSize;

  const queryPage = Number(route.query[pageQueryKey]);
  const queryPageSize = Number(route.query[pageSizeQueryKey]);

  const initialPageSize =
    !isNaN(queryPageSize) && queryPageSize > 0 ? queryPageSize : (options.initialPageSize ?? defaultPageSize);

  const initialPage = !isNaN(queryPage) && queryPage > 0 ? queryPage : (options.initialPage ?? 1);

  return {
    initialPage,
    initialPageSize
  };
}
